import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';
import shoppingService from 'v2/services/shopping/subscription';

import type { IShoppingSubscription } from 'v2/interfaces/shopping';

import SubscriptionList from './List';
import SubscriptionQuickview from './Quickview';
import useStyle from './styles';

const Subscription = () => {
  const classes = useStyle();
  const [open] = useObservable(() => shoppingService.getQuickview(), []);

  useObservable(() => shoppingService.load(), []);

  const closeQuickview = useCallback(() => shoppingService.closeQuickview(), []);

  const openQuickview = useCallback((shopping: IShoppingSubscription) => {
    shoppingService.openQuickview(shopping);
  }, []);

  return (
    <div id={'shopping-subscriptions'} className={classes.content}>
      <SubscriptionList onClickRow={openQuickview} />
      <SubscriptionQuickview open={open} onClose={closeQuickview} />
    </div>
  );
};

export default Subscription;
